import { useState, useEffect } from 'react'
import { useSelector } from "react-redux"

import { showLoading } from 'services/util'

import { getAuctionUser } from '../redux/selectors'
import { purchaseFixedItem } from '../auctionUtils'

import css from './sass/itembid.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import FixedItemBidInfo from './FixedItemBidInfo'
import FixedItemAmountSelector from './FixedItemAmountSelector'
import FixedItemPurchaseButton from './FixedItemPurchaseButton'
import { calculatePurchaseAmount } from './utils'
import ConfirmFixedItemModal from '../components/ConfirmFixedItemModal'

const successBannerTime = 7

export default function FixedItemPurchase({ item, auctionDetail, auctionState, isCheckedIn }) {

  const [showFixedItemModal, setShowFixedItemModal] = useState(false)
  const [purchaseQuantity, setPurchaseQuantity] = useState()
  const [purchaseItem, setPurchaseItem] = useState()
  const [amount, setAmount] = useState(1)

  const [purchaseResponse, setPurchaseResponse] = useState()

  const auctionUser = useSelector(getAuctionUser);
  const currentUserId = auctionUser?.UserId


  //use effect to calculate how many user is allowed to purchase
  useEffect(() => {
    const nextAmount = calculatePurchaseAmount(amount, item)
    if (nextAmount !== amount) setAmount(nextAmount)

  }, [amount, item])

    const submitPurchase = async (item, purchaseQuantity) => {
  
      //for development
      // return
  
      showLoading(true)
      
      
      const purchaseFields = {
        quantity: purchaseQuantity,
        fixedItemId: item.FixedItemId,
      }
      try {
        const response = await purchaseFixedItem(purchaseFields)
        setPurchaseResponse(response)
  
        console.log('purchase reponse', response)
  
        if (response.error) {
          console.log('errored', response)
          //set failed purchase? to true?
          //setFailedBid(true)
        } else {
          console.log('passed', response)
          const updatedItem = {...item, ...response, timeOut: new Date(new Date().getTime() + (successBannerTime * 1000))}
          
          setShowFixedItemModal(false)
          setAmount(1)
          //setFailedBid(false)

          // TO DO - update for successful purchase banner
          // setSuccessItem(updatedItem)
          // queryClient.invalidateQueries(["auctionDetail"])
        }
      }
      catch(e) {
        setPurchaseResponse(e)
      }
      //reset bid response for downstream checks on bid response
      showLoading(false)
    }

  return (
    <>
      {/* {updatedItem && <BidSuccessNotification successItem={updatedItem} auctionDetail={auctionDetail} />} */}
      <div className={`${css['bid-container']} ${themeCss['shadowed']}`}>
        <p className={css['bid-title']}>{item.Title}</p>

        <FixedItemBidInfo auctionState={auctionState} item={item} 
                auction={auctionDetail} currentUserId={currentUserId} /> 

        {isCheckedIn && auctionState === 'started' &&
          <>
            <>
              <div className={`${css['purchase-selector-container']}`} >
                <FixedItemAmountSelector item={item} amount={amount} setAmount={setAmount} />
              </div>
              <div className={`${css['purchase-selector-container']}`} >
                <FixedItemPurchaseButton amount={amount} setShowFixedItemModal={setShowFixedItemModal} 
                  setPurchaseQuantity={setPurchaseQuantity} setPurchaseItem={setPurchaseItem} item={item} />
              </div>
            </>
            {showFixedItemModal && <ConfirmFixedItemModal submitFn={submitPurchase} item={purchaseItem} 
              purchaseQuantity={purchaseQuantity} auctionDetail={auctionDetail}
              showFixedItemModal={showFixedItemModal} setShowFixedItemModal={setShowFixedItemModal} 
              purchaseResponse={purchaseResponse} setPurchaseResponse={setPurchaseResponse} />}
          </>}

      </div>
    </>
  )
}